// extracted by mini-css-extract-plugin
export default {"form":"patientFormModal_form__KSQFk","submitButton":"patientFormModal_submitButton__14uBq"};